import * as React from 'react';
import { ROLE } from './Role';
import { JWTSession } from '../shared/session/JWTSession';

const Login = React.lazy(async () => import('../pages/Login/Login'));
const Register = React.lazy(async () => import('../pages/Register/Register'));
const ThanksForRegister = React.lazy(async () =>
    import('../pages/ThanksForRegister/ThanksForRegister'),
);
const Contact = React.lazy(async () => import('../pages/Contact/Contact'));
const News = React.lazy(async () => import('../pages/News/News'));
const DeclarationOfAvailability = React.lazy(async () => import('../pages/DeclarationOfAvailability/DeclarationOfAvailability'));
const PrivacyPolicy = React.lazy(async () => import('../pages/PrivacyPolicy/PrivacyPolicy'));
const InformationClause = React.lazy(async () => import('../pages/InformationClause/InformationClause'));
const Dashboard = React.lazy(async () => import('../pages/Dashboard'));
const ResetPassword = React.lazy(async () =>
    import('../pages/ResetPassword/ResetPassword'),
);
const SetNewPassword = React.lazy(async () =>
    import('../pages/SetNewPassword/SetNewPassword'),
);
const ActivateAccount = React.lazy(async () =>
    import('../pages/ActivateAccount/ActivateAccount'),
);
const ExpertApplicationForm = React.lazy(async () =>
    import('../pages/ExpertApplicationForm/ExpertApplicationForm'),
);
const ExpertApplicationFormContactDetails = React.lazy(async () =>
    import('../pages/ExpertApplicationForm/Sections/ContactDetails'),
);
const ExpertApplicationFormEducation = React.lazy(async () =>
    import('../pages/ExpertApplicationForm/Sections/Education'),
);
const ExpertApplicationFormWorkExperience = React.lazy(async () =>
    import('../pages/ExpertApplicationForm/Sections/WorkExperience'),
);
const ExpertNfosigwAreaOfActivity = React.lazy(async () =>
    import('../pages/ExpertApplicationForm/Sections/NfosigwAreaOfActivity'),
);
const ExpertQuestionnaire = React.lazy(async () =>
    import('../pages/ExpertApplicationForm/Sections/Questionnaire'),
);
const ExpertAttachments = React.lazy(async () =>
    import('../pages/ExpertApplicationForm/Sections/Attachments'),
);
const Unauthorized = React.lazy(async () =>
    import('../pages/Unauthorized/Unauthorized'),
);
const Experts = React.lazy(async () => import('../pages/Experts/Experts'));
const ExpertFormPreview = React.lazy(async () =>
    import('../pages/Experts/ExpertFormPreview'),
);
const ExpertFormHistory = React.lazy(async () =>
    import('../pages/Experts/History'),
);
const Flashcards = React.lazy(async () =>
    import('../pages/Secretary/Flashcards'),
);
const FlashcardPreview = React.lazy(async () =>
    import('../pages/Secretary/FlashcardPreview'),
);
const AssignExpert = React.lazy(async () =>
    import('../pages/AssignExpert'),
);
const EvaluationInvitationList = React.lazy(async () =>
    import('../pages/EvaluationInvitation/EvaluationInvitationList'),
);
const EvaluationInvitationListRejected = React.lazy(async () =>
    import('../pages/EvaluationInvitation/EvaluationInvitationListRejected'),
);
const FlashCardsList = React.lazy(async () =>
    import('../pages/Flashcards/FlashCardsList'),
);
const FlashCardsListRated = React.lazy(async () =>
    import('../pages/Flashcards/FlashCardsListRated'),
);

const EvaluationForm = React.lazy(async () =>
    import('../pages/Flashcards/EvaluationForm'),
);
const AdminPage = React.lazy(async () =>
    import('../pages/Admin/Admin'),
);
export interface RoutingItem {
    Cmp?: () => React.ReactComponentElement<any>;
    title: string;
    path: string;
    authorizedRoles: Array<ROLE>;
    icon?: React.ReactComponentElement<any>;
    hideInMenu?: boolean;
    children?: Array<RoutingItem>;
    exact?: boolean;
}

export type Modules =
    'Login' |
    'Register' |
    'ResetPassword' |
    'SetNewPassword' |
    'Dashboard' |
    'ActivateAccount' |
    'ThanksForRegister' |
    'Unauthorized' |
    'ExpertRegisterForm' |
    'News' |
    'Contact' |
    'DeclarationOfAvailability' |
    'PrivacyPolicy' |
    'InformationClause' |
    'Experts' |
    //'EvaluationInvitationList' |
    //'FlashCardsList' |
    //'Flashcards' |
    'Admin'

export const modules: Record<Modules, RoutingItem> = {
    Login: {
        Cmp: () => <Login />,
        title: 'Logowanie',
        path: '/login',
        authorizedRoles: [],
        hideInMenu: true,
    },
    Register: {
        Cmp: () => <Register />,
        title: 'Rejestracja',
        path: '/register',
        authorizedRoles: [],
        hideInMenu: true,
    },
    ThanksForRegister: {
        Cmp: () => <ThanksForRegister />,
        title: 'Dziękujemy za rejestracje',
        path: '/thank-you-for-registering',
        authorizedRoles: [],
        hideInMenu: true,
    },
    ResetPassword: {
        Cmp: () => <ResetPassword />,
        title: 'Przypominj hasło',
        path: '/reset-password',
        authorizedRoles: [],
        hideInMenu: true,
    },
    SetNewPassword: {
        Cmp: () => <SetNewPassword />,
        title: 'Ustaw nowe hasło',
        path: '/set-new-password',
        authorizedRoles: [],
        hideInMenu: true,
    },
    ActivateAccount: {
        Cmp: () => <ActivateAccount />,
        title: 'Aktywuj konto',
        path: '/activate-account',
        authorizedRoles: [],
        hideInMenu: true,
    },
    Dashboard: {
        Cmp: () => <Dashboard />,
        title: 'Dashboard',
        path: '/dashboard',
        authorizedRoles: [],
        hideInMenu: true,
    },
    Unauthorized: {
        Cmp: () => <Unauthorized />,
        title: 'Dashboard',
        path: '/unauthorized',
        authorizedRoles: [],
        hideInMenu: true,
    },
    Contact: {
        Cmp: () => <Contact />,
        title: 'Kontakt',
        path: '/contact',
        authorizedRoles: [],
        hideInMenu: true,
    },
    News: {
        Cmp: () => <News />,
        title: 'Aktualności',
        path: '/news',
        authorizedRoles: [],
        hideInMenu: true,
    },
    DeclarationOfAvailability: {
        Cmp: () => <DeclarationOfAvailability/>,
        title: 'Deklaracja dostępności serwisu',
        path: '/declarationOfAvailability',
        authorizedRoles: [],
        hideInMenu: true,
    },
    PrivacyPolicy: {
        Cmp: () => <PrivacyPolicy/>,
        title: 'Polityka prywatności',
        path: '/privacyPolicy',
        authorizedRoles: [],
        hideInMenu: true,
    },
    InformationClause: {
        Cmp: () => <InformationClause/>,
        title: 'Klauzula informacyjna',
        path: '/informationClause',
        authorizedRoles: [],
        hideInMenu: true,
    },
    Experts: {
        Cmp: () => <Experts />,
        title: 'Eksperci',
        path: '/experts',
        authorizedRoles: [ROLE.Secretary],
        hideInMenu: false,
        children: [
            {
                Cmp: () => <Experts />,
                title: 'Eksperci',
                path: '/',
                authorizedRoles: [],
                exact: true,
                hideInMenu: true,
            },
            {
                Cmp: () => <ExpertFormPreview />,
                title: 'Podgląd profilu',
                path: '/preview/:expertRegistrationFormId',
                authorizedRoles: [],
                exact: true,
                hideInMenu: true,
            },
            {
                Cmp: () => <ExpertFormHistory />,
                title: 'Historia',
                path: '/history/:expertRegistrationFormId',
                authorizedRoles: [],
                exact: true,
                hideInMenu: true,
            },
            // {
            //     Cmp: () => <p>test</p>,
            //     title: 'Test sub nav',
            //     path: '/test-sub-nav',
            //     authorizedRoles: [],
            //     exact: true,
            //     hideInMenu: false,
            // },
        ]
    },
    /*Flashcards: {
        title: 'Fiszki',
        path: '/flashcards',
        authorizedRoles: [ROLE.Secretary],
        hideInMenu: false,
        children: [
            {
                Cmp: () => <Flashcards />,
                title: 'Fiszki2',
                path: '/',
                authorizedRoles: [ROLE.Secretary],
                exact: true,
                hideInMenu: true,
            },
            {
                Cmp: () => <FlashcardPreview />,
                title: 'Fiszka',
                path: '/preview/:flashcardId',
                authorizedRoles: [],
                exact: true,
                hideInMenu: true
            },
            {
                Cmp: () => <EvaluationForm />,
                title: 'Formularz oceny fiszki',
                path: '/preview/:flashcardId/evaluation/:flashcardEvaluationInvitationId',
                authorizedRoles: [],
                exact: true,
                hideInMenu: true,
            },
            {
                Cmp: () => <AssignExpert />,
                title: 'Fiszka',
                path: '/preview/:flashcardId/assign-expert',
                authorizedRoles: [],
                exact: true,
                hideInMenu: true,
            },
        ],
    },
    EvaluationInvitationList: {
        Cmp: () => <EvaluationInvitationList />,
        title: 'Zaproszenia',
        path: '/evaluationinvitation',
        authorizedRoles: [ROLE.Expert],
        hideInMenu: false,
        children: [
            {
                Cmp: () => <EvaluationInvitationList />,
                title: 'Fiszki1',
                path: '/',
                authorizedRoles: [],//ROLE.Expert
                exact: true,
                hideInMenu: true,
            },
            {
                Cmp: () => <EvaluationInvitationListRejected />,
                title: 'Nieaktywne',
                path: '/rejected',
                authorizedRoles: [],//ROLE.Expert
                exact: true,
                hideInMenu: true,
            },
        ],
    },
    FlashCardsList: {
        title: 'Fiszki',
        path: '/flashcardslist',
        authorizedRoles: [ROLE.Expert],//ROLE.Expert
        hideInMenu: false,
        children: [
            {
                Cmp: () => <FlashCardsList />,
                title: 'Do oceny',
                path: '/',
                authorizedRoles: [],//ROLE.Expert
                exact: true,
                hideInMenu: false,
            },
            {
                Cmp: () => <FlashCardsListRated />,
                title: 'Ocenione',
                path: '/rated',
                authorizedRoles: [],//ROLE.Expert
                exact: true,
                hideInMenu: false,
            },
            {
                Cmp: () => <EvaluationForm />,
                title: 'Formularz oceny fiszki',
                path: '/rate/:flashcardEvaluationInvitationId',
                authorizedRoles: [],//ROLE.Expert
                exact: true,
                hideInMenu: true,
            },
            // {
            //     Cmp: () => <ExpertFormPreview />,
            //     title: 'Podgląd wniosku',
            //     path: '/preview/:expertRegistrationFormId',
            //     authorizedRoles: [],
            //     exact: true,
            //     hideInMenu: true,
            // },
        ],
    },*/
    ExpertRegisterForm: {
        title: 'Profil eksperta',
        path: '/expert-application',
        authorizedRoles: [ROLE.NewUser, ROLE.Expert],
        hideInMenu: false,
        children: [
            {
                Cmp: () => <ExpertApplicationForm />,
                title: 'Podsumowanie',
                path: '/',
                authorizedRoles: [],
                exact: true,
                hideInMenu: true,
            },
            {
                Cmp: () => <ExpertApplicationFormContactDetails />,
                title: 'Dane teleadresowe',
                path: '/contact-details/:expertRegistrationFormId',
                exact: true,
                authorizedRoles: [],
                hideInMenu: true,
            },
            {
                Cmp: () => <ExpertApplicationFormEducation />,
                title: 'Wykształcenie',
                path: '/education/:expertRegistrationFormId',
                exact: true,
                authorizedRoles: [],
                hideInMenu: true,
            },
            {
                Cmp: () => <ExpertApplicationFormWorkExperience />,
                title: 'Przebieg pracy zawodowej',
                path: '/experience/:expertRegistrationFormId',
                exact: true,
                authorizedRoles: [],
                hideInMenu: true,
            },
            {
                Cmp: () => <ExpertNfosigwAreaOfActivity />,
                title: 'Obszar działalności NFOŚiGW',
                path: '/nfosigw/:expertRegistrationFormId',
                exact: true,
                authorizedRoles: [],
                hideInMenu: true,
            },
            {
                Cmp: () => <ExpertQuestionnaire />,
                title: 'Kwestionariusz uzupełniający',
                path: '/questionnaire/:expertRegistrationFormId',
                exact: true,
                authorizedRoles: [],
                hideInMenu: true,
            },
            {
                Cmp: () => <ExpertAttachments />,
                title: 'Załączniki',
                path: '/attachments/:expertRegistrationFormId',
                exact: true,
                authorizedRoles: [],
                hideInMenu: true,
            },
        ],
    },
    Admin: {
        Cmp: () => <AdminPage />,
        title: 'Panel admina',
        path: '/admin',
        authorizedRoles: [ROLE.SuperUser],
        hideInMenu: true,
    },
};

export const defaultRoute = '/dashboard';

export const routing: Array<RoutingItem> = Object.values(modules);

export const getDefaultRedirectPathForRole = (session: JWTSession): string => {
    const role = session.data?.roles[0];

    if (role === ROLE.NewUser) {
        return modules.ExpertRegisterForm.path;
    }
    else if (role === ROLE.Secretary) {
        return modules.Experts.path;
        // return modules.Flashcards.path;
    }
    else if (role === ROLE.Expert) {
        return modules.ExpertRegisterForm.path;
        // return modules.Dashboard.path;
    }
    if(role === ROLE.SuperUser) {
        return modules.Admin.path;
    }
    return modules.Unauthorized.path;
};

      

